import type { MangaItem } from "@/mocks/comics";

interface ChapterListProps {
  comic: MangaItem;
  activeSlug: string;
  onSelect: (slug: string) => void;
}

export default function ChapterList({ comic, activeSlug, onSelect }: ChapterListProps) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-file-list-3-line text-primary-500" aria-hidden="true" />
          章节列表
        </h2>
        <span className="text-xs text-foreground-600">
          共 {comic.chapters.length} 话 · 免费阅读
        </span>
      </div>
      <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
        {comic.chapters.map((chapter) => {
          const active = chapter.slug === activeSlug;
          return (
            <li key={chapter.slug}>
              <button
                type="button"
                onClick={() => onSelect(chapter.slug)}
                aria-current={active ? "true" : undefined}
                className={`flex w-full items-center justify-between gap-2 rounded-md border px-3 py-2.5 text-left text-sm transition-colors cursor-pointer ${
                  active
                    ? "border-primary-500 bg-primary-50 text-primary-700 font-medium"
                    : chapter.isLatest
                      ? "border-accent-300 bg-accent-50/60 text-foreground-900 hover:border-accent-400 hover:bg-accent-100/60"
                      : "border-background-200/70 bg-background-50 text-foreground-800 hover:border-primary-300 hover:bg-primary-50/50"
                }`}
              >
                <span className="truncate">{chapter.title}</span>
                {chapter.isLatest && (
                  <span className="ml-1 shrink-0 whitespace-nowrap rounded-full bg-accent-500 px-1.5 py-0.5 text-[10px] font-medium text-background-50">
                    大结局
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}